import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import HeroBanner from './components/HeroBanner';
import WelcomeSection from './components/WelcomeSection';
import EventPhotosGallery from './components/EventPhotosGallery';
import FestivalCatalogue from './components/FestivalCatalogue';
import FeaturedSection from './components/FeaturedSection';
import Testimonials from './components/Testimonials';
import Sponsors from './components/Sponsors';
import Footer from './components/Footer';
import About from './pages/About';
import Rules from './pages/Rules';
import Gaff2025 from './pages/Gaff2025';
import Gaff2026 from './pages/Gaff2026';
import Contact from './pages/Contact';
import Team from './pages/Team';
import { Toaster } from './components/ui/toaster';
import './App.css';

const HomePage = () => {
  return (
    <>
      <Header />
      <HeroBanner />
      <WelcomeSection />
      <FeaturedSection />
      <Testimonials />
      <EventPhotosGallery />
      <FestivalCatalogue />
      <Sponsors />
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App bg-black">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<About />} />
        <Route path="/team" element={<Team />} />
        <Route path="/rules" element={<Rules />} />
        <Route path="/gaff-2025" element={<Gaff2025 />} />
        <Route path="/gaff-2026" element={<Gaff2026 />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Toaster />
    </div>
  );
}

export default App;